import {useEffect, useState} from 'react';

import {
  DirectRelationshipData,
  ImpactAnalysisView,
  ListNodeData,
} from 'src/types';
import {
  getDirectRelationships,
  getImpact,
} from 'src/api/dependency';

export const useDirectRelationships = (nodeId?: string) => {
  const [directRelationships, setDirectRelationships] = useState<Array<DirectRelationshipData> | undefined>();

  const fetchDirectRelationshipsByNodeId = async (nodeId: string) => {
    setDirectRelationships(undefined);
    const response = await getDirectRelationships(nodeId);
    if (response?.data?.status === 'success' && response?.data?.data) {
      setDirectRelationships(response.data.data);
    } else {
      setDirectRelationships([]);
    }
  };

  useEffect(() => {
    if (nodeId) {
      fetchDirectRelationshipsByNodeId(nodeId);
    }
  }, [nodeId]);

  const loading = !directRelationships;

  return {loading, directRelationships, fetchDirectRelationshipsByNodeId};
};

export const useImpact = (nodeId?: string) => {
  const [impact, setImpact] = useState<Array<ListNodeData> | undefined>();

  const fetchImpactByNodeId = async (nodeId: string) => {
    setImpact(undefined);
    const response = await getImpact(nodeId);
    if (response?.data?.status === 'success' && response?.data?.data) {
      const inboundNodes = computeInboundNodes(nodeId, response.data.data);
      setImpact(inboundNodes);
    } else {
      setImpact([]);
    }
  };

  useEffect(() => {
    if (nodeId) {
      fetchImpactByNodeId(nodeId);
    }
  }, [nodeId]);

  const loading = !impact;

  return {loading, impact, fetchImpactByNodeId};
};


const computeInboundNodes = (id: string, impactView: ImpactAnalysisView) => {
  const inboundIds: string[] = impactView.relationships
      .filter((r) => {
        return r.endId === id;
      })
      .map((r) => {
        return r.startId;
      });

  return impactView?.nodes.filter((n) => inboundIds.indexOf(n.id) >= 0);
};

